// extracted by mini-css-extract-plugin
export default {"header-container":"Reseller_header-container__GLEt6","flex":"Reseller_flex__rX2gj"};